// extracted by mini-css-extract-plugin
module.exports = {"root":"tab-appointments_root__2SXE6"};